<template>
	<Overlay
		title="Google Chrome"
		ref="overlay"
		class="overlay--browser"
		:root="true"
		@close="onClose"
		@afterhide="onAfterHide"
	>
		<template #body>
			<slot name="body">
				<p>We merken dat je een andere browser gebruikt dan <a href="https://www.google.com/intl/nl/chrome/?brand=YTUH&gclid=CjwKCAiAs8acBhA1EiwAgRFdw9nUdzYOLNrC0L3sM6Ac7vZ3XX_7Bn3chtmFDnqazKESPK2MVGCapBoCMGkQAvD_BwE&gclsrc=aw.ds">Google Chrome</a>. Voor de best mogelijke gebruikservaring raden we steeds het gebruik van <a href="https://www.google.com/intl/nl/chrome/?brand=YTUH&gclid=CjwKCAiAs8acBhA1EiwAgRFdw9nUdzYOLNrC0L3sM6Ac7vZ3XX_7Bn3chtmFDnqazKESPK2MVGCapBoCMGkQAvD_BwE&gclsrc=aw.ds">Google Chrome</a> aan.</p>
				<p>Je kan je huidige browser verder gebruiken, maar het is mogelijk dat bepaalde functionaliteiten niet beschikbaar zijn of niet werken zoals het hoort.</p>
				<p><a href="https://www.google.com/intl/nl/chrome/?brand=YTUH&gclid=CjwKCAiAs8acBhA1EiwAgRFdw9nUdzYOLNrC0L3sM6Ac7vZ3XX_7Bn3chtmFDnqazKESPK2MVGCapBoCMGkQAvD_BwE&gclsrc=aw.ds">Download Google Chrome.</a></p>
				<FormKit
					v-model="checked"
					type="checkbox"
					label="Deze melding niet meer tonen."
				/>
			</slot>
		</template>
		<template #footer>
			<div class="footer-actions-group">
				<button
					class="button button button--filled button--big"
					@click="onClose"
				>
					Sluiten
				</button>
			</div>
		</template>
	</Overlay>
</template>

<script src="./BrowserNotice.js"></script>
